import { FC } from 'react';
import {
  Button,
  TextTitle,
  TextBody,
  Spacer,
  Stack,
  BlockList,
  Input,
  Select,
  SelectOption,
  Icon,
  Tooltip,
} from '@pypestream/design-system';
import { FieldValues, SubmitHandler, useFormContext } from 'react-hook-form';
import { Providers } from '../../../xstate/prostudio.api-service.types';

export const StepCreateAiProvider: FC<{
  nextStep: SubmitHandler<FieldValues>;
  backStep?: () => void;
  providers?: Providers;
}> = ({ nextStep, backStep, providers }) => {
  const formContext = useFormContext();
  const { register, handleSubmit } = formContext;

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <TextTitle size="small" textAlign="center">
        Create AI Provider connection
      </TextTitle>
      <Spacer size="small" />
      <TextBody variant="secondary" textAlign="center">
        Set up access to models by providing a name and API key for an AI
        Provider.
      </TextBody>
      <Spacer size="xlarge" />

      <BlockList gutter="large">
        <div>
          <Stack alignItems="center" gutter="2xsmall">
            <TextBody size="small">AI Provider</TextBody>
            <Tooltip
              placement="right"
              content="The name of your company or brand. This helps the model respond in a way that aligns with your brand identity."
            >
              <Icon name="info" color="gray" size="xsmall" />
            </Tooltip>
          </Stack>
          <Spacer size="2xsmall" />
          <Select
            variant="outlined"
            placeholder="Select AI Provider"
            {...register('llmProviderId', { required: true })}
          >
            {providers?.map((provider) => (
              <SelectOption key={provider.id} value={provider.id}>
                <Icon name="gemini" size="small" slot="prefix" />
                {provider.name}
              </SelectOption>
            ))}
          </Select>
        </div>
        <div>
          <TextBody size="small">Connection Name</TextBody>
          <Spacer size="2xsmall" />
          <Input
            variant="outlined"
            placeholder="Connection Name"
            {...register('name', { required: true })}
          />
        </div>
        <div>
          <TextBody size="small">API Key</TextBody>
          <Spacer size="2xsmall" />
          <Input
            variant="outlined"
            placeholder="API Key"
            {...register('apiKey', { required: true })}
          />
        </div>
      </BlockList>

      <Spacer size="xlarge" />
      <Stack justifyContent="space-between">
        <Button size="large" variant="ghost" onClick={backStep}>
          Back
        </Button>
        <Button size="large" onClick={handleSubmit(nextStep)}>
          Next
        </Button>
      </Stack>
    </form>
  );
};
